import React from 'react'
import Select from 'react-select';
const GeneralAccInfo = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const CompanyOption = [
        { value: 'Company', label: 'Company' },
        { value: 'Non-Company', label: 'Non-Company' },
    ]
    return (
        <div>   <form>
            <div className="row">

                <div className="col-md-6">
                    <div className="mb-3">
                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                            <label htmlFor="name" className="form-label mb-0 text-label-red">
                                Credit Limit
                            </label>
                            <div className="mb-0 form-check">
                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                <label className="form-label mb-0" htmlFor="exampleCheck1">
                                    Unlimited
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-9 pe-0">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    placeholder='Enter Branch Name'
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                // value={formik.values.name}
                                />
                            </div>
                            <div className="col-3">
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                        {/* {formik.touched.name && formik.errors.name ? (
            <div className="error">{formik.errors.name}</div>
        ) : null} */}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                            <label htmlFor="name" className="form-label mb-0 text-label-red">
                                Credit On Hold
                            </label>
                            <div className="mb-0 form-check">
                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                {/* <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                        Unlimited
                                                    </label> */}
                            </div>
                        </div>

                        <input
                            type="text"
                            className="form-control form-control-sm"
                            id="name"
                            name="name"
                            placeholder='Enter Branch Name'
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.name}
                        />



                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                            <label htmlFor="name" className="form-label mb-0 text-label-red">
                                Receivable Credit Period
                            </label>
                            {/* <div className="mb-0 form-check">
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                        Unlimited
                                                    </label>
                                                </div> */}
                        </div>
                        <div className="row">
                            <div className="col-9 pe-0">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    placeholder='Enter Branch Name'
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                // value={formik.values.name}
                                />
                            </div>
                            <div className="col-3">
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                        {/* {formik.touched.name && formik.errors.name ? (
            <div className="error">{formik.errors.name}</div>
        ) : null} */}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">
                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                            <label htmlFor="name" className="form-label mb-0 text-label-red">
                                Payable Credit Period
                            </label>
                            {/* <div className="mb-0 form-check">
                                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                                    <label className="form-label mb-0" htmlFor="exampleCheck1">
                                                        Unlimited
                                                    </label>
                                                </div> */}
                        </div>
                        <div className="row">
                            <div className="col-9 pe-0">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    placeholder='Enter Branch Name'
                                // onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                // value={formik.values.name}
                                />
                            </div>
                            <div className="col-3">
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                        {/* {formik.touched.name && formik.errors.name ? (
            <div className="error">{formik.errors.name}</div>
        ) : null} */}
                    </div>
                </div>
                <div className="col-6">
                    <div className=" mb-1 ">
                        {/* <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                Optional Criteria for credit period applicable to Forwarding
                                                </label> */}
                        <div className="mb-0 form-check">
                            <label className="form-label mb-0 text-label-red" htmlFor="exampleCheck1">
                                Optional Criteria for credit period applicable to Forwarding
                            </label>
                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        </div>
                    </div>
                    <div className="mb-3">

                        <label htmlFor="name" className="form-label mb-1 text-label-red">
                            Receivable
                        </label>
                        <div className="mb-1 d-flex justify-content-start align-items-center gap-1">
                            <Select

                                className='custom-selector w-100'
                                options={ApplicableOption}
                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                            // onBlur={formik.handleBlur}
                            />
                            <Select

                                className='custom-selector w-100'
                                options={ApplicableOption}
                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                            // onBlur={formik.handleBlur}
                            />
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="name"
                                name="name"
                                placeholder='Enter Address'
                            // onChange={formik.handleChange}
                            // onBlur={formik.handleBlur}
                            // value={formik.values.name}
                            />
                            {/* {formik.touched.name && formik.errors.name ? (
            <div className="error">{formik.errors.name}</div>
        ) : null} */}
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                        {/* <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                Payable Credit Period
                                            </label> */}
                        <div className="mb-0 form-check">
                            <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                            <label className="form-label mb-0 text-label-red" htmlFor="exampleCheck1">
                                Restrict Transactions if Invoice is Overdue
                            </label>
                        </div>
                    </div>
                </div>



            </div>
            <hr />
            <div className="row">
                <div className="col-md-6">
                    <div className="mb-3">

                        <div className="row">
                            <div className="col-8 pe-0">
                                <label htmlFor="name" className="form-label mb-1 text-label-red">
                                    Customer G/L
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                            <div className="col-4">
                                <label htmlFor="name" className="form-label mb-1 text-label-red">
                                    Curr
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-3">

                        <div className="row">
                            <div className="col-8 pe-0">
                                <label htmlFor="name" className="form-label mb-1 text-label-red">
                                    Vendor G/L
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                            <div className="col-4">
                                <label htmlFor="name" className="form-label mb-1 text-label-red">
                                    Curr
                                </label>
                                <Select

                                    className='custom-selector'
                                    options={ApplicableOption}
                                // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                // onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-6">
                    <label htmlFor="name" className="form-label mb-1 text-label-red">
                        Notification Emails
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        id="name"
                        name="name"
                        placeholder='Enter Branch Name'
                    // onChange={formik.handleChange}
                    // onBlur={formik.handleBlur}
                    // value={formik.values.name}
                    />
                </div>
                <div className="col-6">
                    <label htmlFor="name" className="form-label mb-1 text-label-red">
                        Organization Type
                    </label>
                    <Select

                        className='custom-selector'
                        options={CompanyOption}
                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                    // onBlur={formik.handleBlur}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end mt-3 gap-2">
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & New
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Close
                </button>

            </div>


        </form></div>
    )
}

export default GeneralAccInfo